import { render, staticRenderFns } from "./MaintenancePriceChange.vue?vue&type=template&id=055aab98&"
import script from "./MaintenancePriceChange.vue?vue&type=script&lang=js&"
export * from "./MaintenancePriceChange.vue?vue&type=script&lang=js&"
import style0 from "./MaintenancePriceChange.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports